import * as _ from 'lodash';

// does a deep traverse and omits the keys specified
function epDeepOmit(obj: any, keysToOmit: string[]) {
  // create an index object of the keys that should be omitted
  const keysToOmitIndex: {[key: string]: string} =  _.keyBy(_.isArray(keysToOmit) ? keysToOmit : [keysToOmit] );
  return omitFromObject(obj, keysToOmitIndex);
}

function omitFromObject(innerObj: any, keysToOmitIndex: {[key: string]: string}) { // This function will be called recursively
  return _.transform(innerObj, function(result: any, value, key) { // transform to a new object
    if (key in keysToOmitIndex) {
      return;
    }
    result[key] = _.isObject(value) ? omitFromObject(value, keysToOmitIndex) : value;
  });
}
declare module 'lodash' {
  interface LoDashStatic {
    epDeepOmit<TValue>(obj: TValue, keysToOmit: string[]): any;
  }

  interface LoDashExplicitWrapper<TValue> {
    epDeepOmit(obj: TValue, keysToOmit: string[]): LoDashExplicitWrapper<any>;
  }
}

_.mixin({epDeepOmit: epDeepOmit});
